// extracted by mini-css-extract-plugin
module.exports = {"link":"competition-details__styles__link--PSRaZyUG","description":"competition-details__styles__description--3lagYI-x"};